"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getTokenHeaders = exports.getLegacyTokenHeader = exports.getTokenHeader = void 0;

var _storage = require("./storage");

const getTokenHeader = () => {
  return {
    Authorization: `Bearer ${(0, _storage.getToken)()}`
  };
};

exports.getTokenHeader = getTokenHeader;

const getLegacyTokenHeader = () => {
  const legacyToken = (0, _storage.getLegacyToken)();
  return legacyToken ? {
    'Legacy-Authorization': legacyToken
  } : {};
};

exports.getLegacyTokenHeader = getLegacyTokenHeader;

const getTokenHeaders = () => {
  return { ...getTokenHeader(),
    ...getLegacyTokenHeader()
  };
};

exports.getTokenHeaders = getTokenHeaders;